<template>
  <div>
    <div id="app">
      <div class="top">
        <div id="navContainer" class="container">
          <nav class="navbar is-light">
            <div class="navbar-brand">
              <router-link class="navbar-item" to="/">
                <img src="/static/GetCoi-Logo.png">
              </router-link>
              <div class="navbar-burger burger" data-target="navbarExampleTransparentExample" v-on-clickaway="away" @click.stop="toggleActive('navEllipsisMobile')">
                <div v-if="user.email" style="margin-top: 12px; margin-left: 10px;" class="dropdown" ref="navEllipsisMobile">
                  <div class="dropdown-trigger">
                    <div class="icon is-small fa-button">
                      <i class="fa fa-ellipsis-h"></i>
                    </div>
                  </div>
                  <div class="dropdown-menu" id="dropdown-menu3" role="menu">
                    <div class="dropdown-content">
                      <a @click="logout" class="dropdown-item">
                        Logout
                      </a>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div id="navMenuTransparentExample" class="navbar-menu">
              <div class="navbar-start">
                <router-link class="navbar-item" to="/documentation">Getting Started</router-link>
                <router-link v-if="user.email" class="navbar-item" to="/associations">Associations</router-link>
                <router-link v-if="user.email" class="navbar-item" to="/requests">Requests</router-link>
              </div>
              <div class="navbar-end">
                <div class="navbar-item">
                  <template v-if="user.email">
                    <span id="email">{{user.email}}</span>
                    <div style="margin-left: 10px;" class="dropdown" ref="navEllipsis">
                      <div class="dropdown-trigger">
                        <div class="icon is-small fa-button" v-on-clickaway="away" @click.stop="toggleActive('navEllipsis')">
                          <i class=" fa fa-ellipsis-h"></i>
                        </div>
                      </div>
                      <div class="dropdown-menu" id="dropdown-menu3" role="menu">
                        <div class="dropdown-content">
                          <a @click="logout" class="dropdown-item">
                            Logout
                          </a>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
    <div style="padding-top: 52px; padding-bottom: 50px;">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  import tenant from '@/tenant'
  import { mixin as clickaway } from 'vue-clickaway'

  export default {
    name: 'app',
    mixins: [clickaway],
    data: function () {
      return {
        openDropdownRef: {},
        user: {}
      }
    },
    created: function () {
      tenant.app.auth().onAuthStateChanged((user) => {
        if (user) {
          this.user = user
          // this.setSampleAssociation()
        }
      })
      if (this.$route.query['setTenant']) {
        window.sessionStorage.setItem('tenantName', this.$route.query['setTenant'])
      }
    },
    methods: {
      logout() {
        this.$router.push('/')
        tenant.app.auth().signOut().then(() => {
          window.sessionStorage.removeItem('tenantName')
          this.user = {}
        })
      },
      away() {
        if (this.openDropdownRef.classList) {
          this.openDropdownRef.classList.remove('is-active')
          this.openDropdownRef = {}
        }
      },
      toggleActive(ref) {
        if (this.openDropdownRef.classList) {
          this.away()
          return
        }
        if (this.$refs[ref]) {
          this.openDropdownRef = this.$refs[ref]
          this.openDropdownRef.classList.add('is-active')
        }
      },
      setSampleAssociation() {
        console.log('test set sample')
        tenant.initialize().then(() => {
          tenant.firebaseDb.ref('agencies/coastig/associations/-Kz6O2YyO3dJJ3VCeBqg').once('value').then((snapshot) => {
            let sampleAssociation = snapshot.val()
            tenant.firebaseDb.ref('agencies/southerncoastig/associations').push(sampleAssociation)
          })
        })
      }
    }
  }

</script>

<style>
  .opaque {
    opacity: 0.8;
  }

  .input[disabled],
  .textarea[disabled] {
    color: black;
  }

  .page-top {
    margin-top: 30px;
  }

  .arrow-dropdown {}

  .page-header {
    border-bottom: lightgrey 1px solid;
    padding-bottom: 5px;
    margin-bottom: 10px;
    font-size: 20px;
    font-weight: bold;
  }

  #app {
    background-color: #f5f5f5;
    position: fixed;
    width: 100%;
    z-index: 2;
    top: 0;
  }

  .section {
    padding: 2rem 1.5rem;
  }

  .hero-small {
    padding: 1rem 1rem;
    font-size: 22px;
  }

  .crud-page-header {
    position: fixed;
    z-index: 1;
    background-color: white;
    margin-top: 20px;
    padding-top: 10px;
    width: 100vw;
  }

  .crud-page-header hr {
    margin-top: 1.5rem;
    margin-bottom: 0.5rem;
  }

  .crud-buttons {
    margin-top: 22px;
    margin-right: 20px;
  }

  .crud-body {
    margin-top: -20px;
    padding-top: 140px;
    z-index: 0;
  }

  .dropdown-menu {
    margin-left: -150px;
  }

  .list-page-header {
    position: fixed;
    z-index: 1;
    background-color: white;
    margin-top: 20px;
    padding-top: 30px;
    width: 100vw;
    /* hr color #dbdbdb */
  }

  .list-buttons {
    margin-top: -8px;
  }

  .list-body {
    margin-top: -20px;
    padding-top: 120px;
  }

  .is-required {
    border: 1px solid;
    border-color: red !important;
  }

  .fa-button {
    /* margin: 8px 10px 0px 0px; */
    vertical-align: middle;
    font-size: 20px;
    cursor: pointer;
    opacity: 0.8;
  }

  a {
    color: #3273dc;
    cursor: pointer;
    text-decoration: none;
  }

  @media (min-width: 894px) {
    .accord24 {
      left: 50%;
      transform: translateX(-50%);
    }
  }

  @media (max-width: 894px) {
    .accord24 {
      overflow-x: scroll;
    }
  }

  @media (min-width: 768px) {
    .mobile-button {
      display: none;
    }
    .hide-desktop {
      display: none;
    }
  }

  @media (max-width: 768px) {
    #email {
      display: none;
    }
    .hide-mobile {
      display: none;
    }
    .mobile-button {
      float: right;
      margin: -5px 15px 0px 0px;
    }
    .title {
      margin-left: 15px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/App.vue?b47d76b6